import { ARTICLE_DEFAULT_LABEL } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Icon } from "@sagot/ui";

interface ArticlePreviewProps {
  title: string;
  text: string;
  label: string;
}

/** How the card looks in the chat: the title, the author's text and a button that opens the link in a new tab. */
export function ArticlePreview({ title, text, label }: ArticlePreviewProps) {
  const { t } = useTranslation();
  return (
    <figure className="space-y-2" data-testid="article-preview">
      <figcaption className="label mb-0">{t("engage.workflows.article.preview")}</figcaption>
      <div className="rounded-lg border border-line bg-surface p-3 shadow-sm">
        <p className="flex items-start gap-2 text-sm font-semibold">
          <Icon name="book-open" className="mt-0.5 size-4 shrink-0 text-primary-ink" />
          <span className="min-w-0 break-words">{title}</span>
        </p>
        {text ? <p className="mt-1 whitespace-pre-wrap break-words text-xs text-fg-muted">{text}</p> : null}
        <span className="mt-3 inline-flex min-h-9 items-center gap-1.5 rounded-pill border border-primary px-3 text-xs font-semibold text-primary-ink">
          {label || ARTICLE_DEFAULT_LABEL.en}
          <Icon name="external-link" className="size-3.5" />
        </span>
      </div>
    </figure>
  );
}
